import React from "react";
import { Nav } from "shards-react";

import Notifications from "./Notifications";
import DropdownUserMenu from "./DropdownUserMenu";
import HelpCenter from "./HelpCenter";
import { useSelector } from "react-redux";

const NavbarNav = () => {
    
    const { user } = useSelector(state => state.user);

    return (
        <Nav navbar className="border-left flex-row">
            <Notifications />
            {("ROOT" === user.roles[0].name)? // TODO: Remove "ROOT" credential control when documentation will be finished
                <HelpCenter/>
                :null
            }
            <DropdownUserMenu/>
        </Nav>
    );
};


export default NavbarNav;